import {GoogleMap, useJsApiLoader} from '@react-google-maps/api';
import React, {useCallback, useState} from "react";

export function GoogleMapsWidget(props) {
    const containerStyle = {
        width: '100%',
        height: '300px'
    };
    const center = {
        lat: props.lat,
        lng: props.lng
    };
    const {isLoaded} = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyAfpLhr5oQ9WbtiGc2BsRnGhQDKE76cvuE"
    })
    const [map, setMap] = useState(null)
    const onLoad = useCallback(function callback(map) {
        if(!props.lat || !props.lang) {
            return;
        }
        const bounds = new window.google.maps.LatLngBounds();
        const location = new window.google.maps.LatLng(center.lat, center.lng);
        map.fitBounds(bounds);
        map.panTo(location);
        setMap(map)
    }, [])

    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={20}
            onLoad={onLoad}
            onUnmount={onUnmount}
        >
            { /* Child components, such as markers, info windows, etc. */}
            <></>
        </GoogleMap>
    ) : <></>
}
